const BYTE_DIVISOR_BINARY = 1024;
// Confirmed max request size limit through Stargate is 16MB
const DEFAULT_MAX_FILE_SIZE = 16;

const defaultAcceptedFileTypes = [
  "audio/*",
  "image/*",
  "video/*",
  ".txt",
  ".rtf",
  ".csv",
  ".json",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
  ".xls",
  ".xlsx",
  ".pdf",
  ".har",
  ".pcap",
];

const constants = {
  BYTE_DIVISOR_BINARY,
  DEFAULT_MAX_FILE_SIZE,
  defaultAcceptedFileTypes,
};

export default constants;
